
import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class UserService {

    static getAllUsers(page, maxPerPage,UserName, isActive) {
  
    return axios.get(`${BaseUrl}User?page=${page}&maxPerPage=${maxPerPage}&username=${UserName ? UserName : ''}&isActive=${isActive}`);
    }    
    static getUserByUserName(UserName) {
  
        return axios.get(`${BaseUrl}User?id="${UserName}"`);
    }
    static SaveUser(USERNAME, ROLID,RESELLERID, EMAIL) {
        var data = {
            USERNAME: USERNAME,
            ROL: ROLID,
            RESELLERID: RESELLERID
        };
        return axios.post(BaseUrl+ 'User?email='+ EMAIL, data);
    }
    static EditUser(USERNAME, ROLID, RESELLERID, EMAIL) {
        var data = {
            USERNAME: USERNAME,
            ROL: ROLID,
            RESELLERID: RESELLERID
        };
        return axios.put(BaseUrl+ 'User?email='+ EMAIL, data);
    }
    static DeleteUser(id, EMAIL) {
        //var id = serialNumber;
        return axios.delete(`${BaseUrl}User?ID=${id}&email=${EMAIL}`);
    }
}


// WEBPACK FOOTER //
// ./src/Services/userService/userService.js